/**
 * 灵犀点位
 * 所有的 cid、bid
 */
// tslint:disable:trailing-comma
export const enum BridgeBids {
  BridgeStart = 'b_pay_call_bridge_start_sc',
  BridgeSuccess = 'b_pay_call_bridge_succ_sc',
  BridgeExecuteSuccess = 'b_pay_execute_bridge_succ_sc',
  BridgeExecuteFail = 'b_pay_execute_bridge_fail_sc',
}

// 参数通道
export const enum ParamsTunnelBids {
  FetchStart = 'b_pay_neo_param_tunnel_start_sc',
  FetchSuccess = 'b_pay_neo_param_tunnel_succ_sc',
  FetchFail = 'b_pay_neo_param_tunnel_fail_sc',
}

// 预请求数据通道
export const enum PrefetchDataTunnelBids {
  FetchStart = 'b_pay_neo_pre_request_start_sc',
  FetchSuccess = 'b_pay_neo_pre_request_succ_sc',
  FetchFail = 'b_pay_neo_pre_request_fail_sc',
  GetDataStart = 'b_pay_get_prefetch_data_start_sc',
  GetDataAjaxStart = 'b_pay_get_prefetch_data_ajax_start_sc',
  GetDataSuccess = 'b_pay_get_prefetch_data_succ_sc',
  GetDataFail = 'b_pay_get_prefetch_data_fail_sc',
}

// Neo
export const enum NeoBids {
  // TODO 埋点命名重复
  NeoInitEnd = 'b_pay_neo_init_mv',
}

// debug
export const enum DebugBids {
  Debug = 'b_pay_hybrid_cashier_problem_detect_sc',
}

// export const LXPointInfo = {
//   cid: {
//     /**
//      * Hybrid 收银台： https://ocean.sankuai.com/config/#/page/detail?id=41951073&tabName=page&channelId=8
//      */
//     business: 'c_pay_icashier_index',
//     /**
//      * Neo JS：https://ocean.sankuai.com/config/#/page/detail?id=41951664&tabName=page&channelId=8
//      */
//     neojs: 'c_pay_neo_js_sdk',
//   },
//   /**
//    * 渲染相关
//    */
//   // TODO 确认不再使用后删除
//   // render: {
//   //   start: 'b_pay_neo_render_start_mv',
//   //   finished: 'b_pay_neo_render_finish_mv',
//   //   tti: 'b_pay_tti_native_to_render_finished_mv',
//   //   preRenderFinished: 'b_pay_neo_prerender_finish_mv',
//   //   renderHostingException: 'b_pay_neo_render_hosting_exception_mv',
//   //   sendAjax: 'b_pay_neo_send_ajax_mv_mv',
//   //   mountedFinish: 'b_pay_neo_mounted_finish_mv', // 漏斗点位补充：页面渲染成功B（准确）
//   //   hybridRenderFinishPro: 'b_pay_hybrid_render_finish_pro_mv', // SLAPro点位
//   // },
//   /**
//    * 白屏检查
//    */
//   // TODO 确认不再使用后删除
//   // renderCheck: {
//   //   webSkeleton: 'b_pay_neo_render_check_web_skeleton_mv',
//   //   webBusiUi: 'b_pay_neo_render_check_web_busi_ui_mv',
//   //   webResizeEvent: 'b_pay_neo_render_check_web_resize_event_mv',
//   //   webError: 'b_pay_neo_render_check_web_error_mv',
//   // },
//   userBehavior: {
//     touchstart: 'b_pay_neo_user_behavior_touchstart_mv',
//   },
//   sla: {
//     pageStartRender: 'b_pay_hybrid_cashier_render_start_mv',
//     ajaxDispatcherSuccess: 'b_pay_hybrid_request_dispatcher_var_ajax_succ_mv',
//     readDispatcherFromTunnel: 'b_pay_hybrid_get_dispatcher_var_param_tunnel_mv',
//     appForeground: 'b_pay_neo_app_foreground_mv',
//     paramTunelStart: 'b_pay_commonparams_start_mv', // 漏斗点位补充：NEO初始化获取隧道参数开始
//   },
//   api: {
//     neoRequestStart: 'b_pay_neo_request_start_mv',
//     neoRequestSuccess: 'b_pay_neo_request_succ_mv',
//     neoRequestFail: 'b_pay_neo_request_fail_mv',
//   },
//   ability: {
//     dataReadyFromSharkStart: 'b_pay_neo_get_data_from_shark_start_mv',
//     dataReadyFromSharkSuccess: 'b_pay_neo_get_data_from_shark_succ_mv',
//     neoInit: 'b_pay_neo_init_mv',
//   },
// };
